import React from "react";
import type { KgBookOpenIconProps } from "./KgBookOpenIcon.types";

/** Open book icon for retrieved report panel header (14px default). */
export const KgBookOpenIcon: React.FC<KgBookOpenIconProps> = ({
  size = 14,
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    aria-hidden
    className={className}
  >
    <path
      d="M1.16675 1.75H4.66675C5.28559 1.75 5.87908 1.99583 6.31666 2.43342C6.75425 2.871 7.00008 3.46449 7.00008 4.08333V12.25C7.00008 11.7859 6.81571 11.3408 6.48752 11.0126C6.15933 10.6844 5.71421 10.5 5.25008 10.5H1.16675V1.75Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.8333 1.75H9.33333C8.71449 1.75 8.121 1.99583 7.68342 2.43342C7.24583 2.871 7 3.46449 7 4.08333V12.25C7 11.7859 7.18437 11.3408 7.51256 11.0126C7.84075 10.6844 8.28587 10.5 8.75 10.5H12.8333V1.75Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default KgBookOpenIcon;
